import * as cookie from 'js-cookie';
import getConfig from '../config';
import { COOKIE_DOMAIN } from './constants';

const COOKIE_NAME_LANGUAGE = 'jLang';
const COOKIE_NAME_USER_ID_TOKEN = 'id_token';
const COOKIE_NAME_USER_ACCOUNT_ID = 'user_account_id';
const COOKIE_NAME_GHOST_INSPECTOR_TEST = 'ghost_inspector_test';
const COOKIE_SHD = 'shd';
const COOKIE_TRS = 'trs';

const { language } = getConfig();

export const ensureLanguageCookieIsset = () => {
  const persistedLanguage = cookie.get(COOKIE_NAME_LANGUAGE);

  if (!persistedLanguage) {
    cookie.set(COOKIE_NAME_LANGUAGE, language, { domain: COOKIE_DOMAIN });
  }
};

export const getLanguageCookie = (): string => {
  return cookie.get(COOKIE_NAME_LANGUAGE);
};

export const getUserIdTokenFromCookie = () => {
  return cookie.get(COOKIE_NAME_USER_ID_TOKEN) || '';
};

export const getUserAccountIdFromCookie = () => {
  return cookie.get(COOKIE_NAME_USER_ACCOUNT_ID) || '';
};

export const isGhostInspectorTest = () => {
  return Boolean(cookie.get(COOKIE_NAME_GHOST_INSPECTOR_TEST));
};

export const getSHD = (): string => {
  return cookie.get(COOKIE_SHD) || '';
};

export const getTRS = (): string => {
  return cookie.get(COOKIE_TRS) || '';
};
